module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av253-3f1886939e88a099135d72180d62cb5f.jpg";